import { useEffect, useState } from "react";
import {
  getCollectionOrderById,
  updateCollectionorderApi,
} from "@/api/collectionOrder";

export const useUpdateCollectionOrder = (collectionId: string) => {
  const [defaultValues, setDefaultValues] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const response = await getCollectionOrderById(collectionId);
        setDefaultValues(response); // Set fetched client data as default values
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch client data");
        setLoading(false);
      }
    };

    fetchCollection();
  }, [collectionId]);

  const updateCollection = async (updatedData: any) => {
    try {
      console.log("data", updatedData);
      const response = await updateCollectionorderApi(
        collectionId,
        updatedData
      );
      console.log("res", response);
      return response;
    } catch (err) {
      throw new Error("Failed to update client");
    }
  };

  return { defaultValues, loading, error, updateCollection };
};
